import React from 'react';
import {withRouter} from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from "@material-ui/core/TextField";
import {Tooltip} from "@material-ui/core";

import MinusIcon from '@material-ui/icons/RemoveCircleOutline';
import PlusIcon from '@material-ui/icons/Add';
import StarIcon from '@material-ui/icons/Star';
import HelpCenterIcon from '@material-ui/icons/ContactSupport';
import RefreshIcon from '@material-ui/icons/RefreshSharp';
import LogOutIcon from '@material-ui/icons/ExitToApp';
import PersonIcon from '@material-ui/icons/PersonOutline';
import MenuBook from '@material-ui/icons/MenuBook';
import Group from '@material-ui/icons/Group';
import Download from '@material-ui/icons/GetApp'

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from '@beardeddevops/react.framework';
import UserRoles from "constants/UserRoles";
import Notifications from "./Notifications";
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown'
import Cookies from 'universal-cookie';
import APPCONFIG from "../../constants/Config";
import {Box} from "@material-ui/core";

class NavRightList extends React.Component {

	constructor(props) {
		super(props);
		this.model = new API.BuildClass(Types.Accounts._name, API.RequestType.READ);
		this.state = {
			anchorEl: null,
			favAnchorEl: null,
			menuItems: [...this.props.rootState.favorites ?? []],
			newItem: '',
			show_addition: false
		};
		this.handleLogout = this.handleLogout.bind(this);
		this.state.notifications = props.notifications;
		this.textFieldRef = React.createRef();
	}

	//
	// async componentDidMount() {
	// 	let data = await this.props.rootState.triggerAction('getUserInformation', null);
	// }

	async componentDidUpdate(prevProps, prevState, snapshot) {
		// if (prevState.main_role !== this.state.main_role && this.state.main_role && prevState.main_role) {
		// 	localStorage.setItem('main_role', this.state.main_role)
		// 	await this.props.rootState.triggerAction('getUserInformation', null);
		// }
		if (prevProps.notifications !== this.props.notifications) {
			this.setState({notifications: this.props.notifications ?? []})
		}
	}

	handleRoute = (value) => {
		this.props.history.push(value);
		this.setState({anchorEl: null});
	};

	handleOpen = event => {
		this.setState({anchorEl: event.currentTarget});
	};

	handleClose = () => {
		this.setState({anchorEl: null});
	};

	handleOpenFavorites = event => {
		this.setState({favAnchorEl: event.currentTarget});
	};

	handleAddItem = async () => {
		const {newItem, menuItems} = this.state;
		if (newItem) {
			const newObject = {'name': newItem, 'link': window.location.href.split('.com')[1]};
			this.setState({
				menuItems: [...menuItems, newObject],
				newItem: '', // Reset input after adding
			});
			let model = new API.BuildClass(Types.Users_Favorites._name, API.RequestType.UPDATE);
			model.object.favorites = [...menuItems, newObject];
			await model.submit(null, 'POST');
		}
		this.toggleShowAdditionMenu().then();
	};

	handleRemoveItem = async (itemToRemove) => {
		const {menuItems} = this.state;
		let newMenu = menuItems.filter((item) => item !== itemToRemove);
		this.setState({
			menuItems: newMenu,
		});
		let model = new API.BuildClass(Types.Users_Favorites._name, API.RequestType.UPDATE);
		model.object.favorites = newMenu;
		await model.submit(null, 'POST');
	};

	handleCloseFavorites = () => {
		this.setState({favAnchorEl: null});
	};

	handleInputChange = (event) => {
		this.setState({ newItem: event.target.value });
	};

	toggleShowAdditionMenu = async () => {
		await this.setState({show_addition: !this.state.show_addition})
		if(this.textFieldRef.current) {
			this.textFieldRef.current.focus();
		}
	}

	handleEnterKeyPressAdd = (event) => {
		if (event.key === 'Enter') {
			this.handleAddItem();
		}
	};

	handleLogout = async (event) => {
		if (typeof event !== 'undefined') event.preventDefault();
		await this.model.submit(null, API.RequestType.DELETE);
		let cookies = new Cookies();
		cookies.remove('auth_pkey');
		cookies.remove('hash');
		this.props.rootState.triggerAction('logout');
		return false;
	};

	render() {
		const {anchorEl, favAnchorEl} = this.state;
		let {name, roles} = this.props;
		if(window.innerWidth <1200){
			name = name.split(' ');
			name = name[0][0] + name[1][0];
		}
		return (
			<ul className="list-unstyled float-right">
				<li>

					<Button
						aria-owns={favAnchorEl ? 'favorites-menu' : null}
						aria-haspopup="true"
						onClick={this.handleOpenFavorites}
						className="md-button header-btn menu-button sm-button"
					>
						<StarIcon/>
						<span className={'full-width'}>Favs</span>
						<KeyboardArrowDown/>
					</Button>
					<Menu
						id="favorites-menu"
						anchorEl={favAnchorEl}
						open={Boolean(favAnchorEl)}
						onClose={this.handleCloseFavorites}
						getContentAnchorEl={null}
						anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
						transformOrigin={{horizontal: 'right', vertical: 'top'}}
					>
						{this.state.menuItems.map((item, index) => (
							<MenuItem className={"d-flex justify-content-between"} key={index} onClick={() => this.handleRoute(item.link)}>
									<span>{item.name}</span>
								{this.state.show_addition &&
									<MinusIcon color={"error"} fontSize={"large"} onClick={() => this.handleRemoveItem(item)}/>
								}
							</MenuItem>
						))}


						{this.state.show_addition &&
							<div>
								<MenuItem disabled={!this.state.newItem} onClick={this.handleAddItem}>{!this.state.newItem ? "Favorite name:" : <><PlusIcon color={"primary"} style={{ fontSize: 26 }}/>Add Current Page</>}</MenuItem>
								<Box
									role="menuitem"
									onKeyDown={(e) => e.stopPropagation()}
								>
									<TextField
										inputRef={this.textFieldRef}
										value={this.state.newItem}
										onChange={this.handleInputChange}
										onKeyPress={this.handleEnterKeyPressAdd}
										label="Fav Name"
										variant="outlined"
										size="small"
									/>
								</Box>
							</div>
						}
						<Tooltip
						         title={!this.state.show_addition ? "Add current page to favorites" : ""}
						         arrow>

							<MenuItem onClick={this.toggleShowAdditionMenu}>
								{!this.state.show_addition ? <> <PlusIcon color={"primary"} style={{ fontSize: 26 }}/>Add/Remove<MinusIcon color={"error"} style={{ fontSize: 24 }}/> </> : "Cancel"}
							</MenuItem>
						</Tooltip>

					</Menu>

					<Notifications notifications={this.state.notifications ?? []} history={this.props.history} key={(this.state.notifications ?? []).length}
					               user={this.props.rootState.user ?? null} triggerSessionCheck={() => this.props.rootState.triggerAction('handleSessionCheck')}/>


					<Button
						name="anchorEl"
						aria-owns={anchorEl ? 'user-menu' : null}
						aria-haspopup="true"
						onClick={this.handleOpen}
						className="md-button header-btn menu-button"
						style={{
							maxWidth: '180px',
							overflow: 'hidden',
						}}
					>
						<PersonIcon/>
						<span
							style={{
								display: 'inline-block',
								maxWidth: '100%',
								overflow: 'hidden',
								whiteSpace: 'nowrap',
								textOverflow: 'ellipsis',
							}}
						>{name}</span>
						<KeyboardArrowDown/>
					</Button>
					<Menu
						id="user-menu"
						anchorEl={anchorEl}
						open={Boolean(anchorEl)}
						onClose={this.handleClose}
						getContentAnchorEl={null}
						anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
						transformOrigin={{horizontal: 'right', vertical: 'top'}}
					>
						{this.props.roles.includes(UserRoles.Admin) &&
							<MenuItem onClick={() => this.handleRoute('/regions')}>
								<ListItemIcon><MenuBook/></ListItemIcon>
								<ListItemText inset primary="Regions"/>
							</MenuItem>
						}
						{this.props.account && <MenuItem onClick={() => this.handleRoute(`/users/${this.props.account}`)}>
							<ListItemIcon><PersonIcon/></ListItemIcon>
							<ListItemText inset primary="User Settings"/>
						</MenuItem>}
						{this.props.roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) &&
							<MenuItem onClick={() => this.handleRoute('/users')}>
								<ListItemIcon><Group/></ListItemIcon>
								<ListItemText inset primary="Users"/>
							</MenuItem>
						}
						<MenuItem onClick={() => window.open("https://karlstechnology.freshdesk.com/")}>
							<ListItemIcon><HelpCenterIcon/></ListItemIcon>
							<ListItemText inset primary="Help Center"/>
						</MenuItem>
						<MenuItem onClick={async () => {
							await API.clearCache();
							this.setState({anchorEl: null});
						}}>
							<ListItemIcon><RefreshIcon/></ListItemIcon>
							<ListItemText inset primary="Clear API Cache"/>
						</MenuItem>
						<MenuItem>
							<a href={`${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/accounts/downloadapp`}
							   style={{display: 'flex', flexDirection: 'row'}}>
								<ListItemIcon><Download/></ListItemIcon>
								<ListItemText inset primary="Download App"/></a>
						</MenuItem>
						<MenuItem onClick={this.handleLogout}>
							<ListItemIcon>
								<LogOutIcon/>
							</ListItemIcon>
							<ListItemText inset primary="Logout"/>
						</MenuItem>
					</Menu>

					{!this.props.roles.includes(UserRoles.FieldEngineer) &&
						<Button onClick={this.handleLogout} data-cy="logout_button" data-id={'logout-button'} className="md-button header-btn laptop-button">
							<LogOutIcon/>
						</Button>}
				</li>
			</ul>
		);
	}
}

export default withRouter(Framework.Components.withRootState(NavRightList));
